module.exports = __webpack_public_path__ + "img/Hairdreams Educator 2.svg";